<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminPlanEditComplete.vue'
export default {
  name: 'staff-plan-edit-complete',
  components: {
    Admin
  }
}
</script>